import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { PlanTypes } from '../models/coverage-models';
import { MemberEnrolledCoverage, MemberEnrolledCoveragePerson } from '../../member/models/member-coverage-model';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { getRelationshipLabel } from '../helpers/coverage-display-helpers';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { replaceAll } from '../../../../../../global/helpers/string-helpers';
import { selectedReviewItemStyles } from '../../../../../../global/constants/theme/styles/components/selected-review-item';


interface Props {
	planType: PlanTypes;	
	groupLabel: string;
	settings: NewHireProps;		
	plan: MemberEnrolledCoverage;	
}
export function PlanItemDisplay(props: Props) {

	const { planType, groupLabel, settings, plan } = props;		

	const classes = selectedReviewItemStyles();

	function RenderPlanName(){
		if (!plan?.plan?.name) return null;

		return ( <h4> {plan?.plan?.name} </h4> );
	}

	function RenderEffectiveDate(){
		if (!plan?.effective_date) return null;

		return ( 
			<div className='form-item'>
				<p><strong>{settings?.effectiveDateLabel}</strong></p>
				<p>{getLetterMonthDate(replaceAll(plan?.effective_date, '-', '/'))}</p>
			</div>
		);		
	}

	function RenderVolume(){		
		if ((planType !== PlanTypes.G) || !plan?.plan?.volume) return null;
		
		return ( 
			<div className='form-item'>
				<p><strong>{settings?.volumeLabel}</strong></p>
				<p>{plan?.plan?.volume}</p>
			</div>
		);
	}

	function RenderRate(){		
		if (!plan?.plan?.rate || planType !== PlanTypes.None) return null;
		
		return ( 
			<div className='form-item'>
				<p><strong>{settings?.rateLabel}</strong></p>
				<p>{plan?.plan?.rate}</p>
			</div>
		);
	}

	function RenderDependent(dependent: MemberEnrolledCoveragePerson){
		if (!dependent) return null;

		const itemKey = `${planType}-dep-${dependent?.first_name?.trim()}-${dependent?.last_name?.trim()}`;

		return (			
			<div className='selected-review-item-inner' key={itemKey}>
				<div className='selected-review-item-content'>
					<CheckIcon className='selected-review-item-icon added' />
					<div>
						<p><strong>{`${dependent?.first_name} ${dependent?.middle_name ? `${dependent?.middle_name} ` : ''}${dependent?.last_name} ${dependent?.suffix}`}</strong></p>
						<p className='input-caption'>{ getRelationshipLabel(dependent?.relationship as any, settings)}</p>
					</div>
				</div>					
			</div>			
		);
	}

	function RenderDependents(){		
		if (!plan?.dependents) return null;

		return (
			<ContentSpacer>
				<div className={`divider-section-item ${classes.selectedReviewItem}`}>            			
					{ plan.dependents.map(dependent => RenderDependent(dependent)) }			
				</div>
			</ContentSpacer>
		);
	}

	return (
		<>
			<DividerSection sectionText={groupLabel} removeDivider >
				<ContentSpacer>
					<div className='grid-main-content'>
						{ RenderDependents() }
						{ RenderPlanName() }
						{ RenderEffectiveDate() }
						{ RenderRate() }
						{ RenderVolume() }
					</div>
				</ContentSpacer>
			</DividerSection>						
		</>
	);
}
